function USPLineIcon({ type }) {
  const common = { viewBox: "0 0 24 24", "aria-hidden": "true" };

  switch (type) {
    case "shield":
      return (
        <svg {...common}>
          <path d="M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6l7-3z" />
          <path d="M9.5 12l1.8 1.8 3.7-4.1" />
        </svg>
      );
    case "cow":
      return (
        <svg {...common}>
          <path d="M6 8l-2-2" />
          <path d="M18 8l2-2" />
          <path d="M7 18v-3" />
          <path d="M17 18v-3" />
          <path d="M7 6h10l2 3v5a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4V9l2-3z" />
          <path d="M9 11h.01" />
          <path d="M15 11h.01" />
          <path d="M10 15c.8.7 3.2.7 4 0" />
        </svg>
      );
    case "worm":
      return (
        <svg {...common}>
          <path d="M5 15c1.2-3 4-4.5 6.5-3.4 1.7.8 2.8 2.5 4.3 3.3 1.5.7 3.1.5 4.2-.8" />
          <path d="M4.5 11.5c1.3-1.8 3.2-2.8 5.2-2.5 2.4.4 3.5 2.4 5.2 3.5 1.7 1.1 3.7 1.2 5.1-.1" />
          <path d="M4 18c1.6 1.8 4 2.5 6.2 1.8" />
        </svg>
      );
    case "certificate":
      return (
        <svg {...common}>
          <path d="M7 4h10a2 2 0 0 1 2 2v11H5V6a2 2 0 0 1 2-2z" />
          <path d="M9 8h6" />
          <path d="M9 11h6" />
          <path d="M9 14h4" />
          <path d="M8 20l4-3 4 3" />
        </svg>
      );
    case "growth":
      return (
        <svg {...common}>
          <path d="M12 20V9" />
          <path d="M8 13c0-2.2 1.8-4 4-4 0 2.2-1.8 4-4 4z" />
          <path d="M16 11c0-2.2-1.8-4-4-4 0 2.2 1.8 4 4 4z" />
          <path d="M6 20h12" />
        </svg>
      );
    case "vitamin":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 20V10"></path>
          <path d="M8 14c2-3 6-3 8 0"></path>
          <path d="M16 6c0 1.7-1.3 3-3 3s-3-1.3-3-3c0-1.7 3-4 3-4s3 2.3 3 4z"></path>
          <path d="M6 20h12"></path>
      </svg>
      );
    default:
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="8" />
        </svg>
      );
  }
}

export default function USPSection() {
  const usps = [
    { icon: "shield", title: "100% Chemical Free", desc: "Absolutely zero chemicals, pesticides or synthetic additives. Pure nature, every time." },
    { icon: "cow", title: "Made from Desi Cow Dung", desc: "Sourced from healthy, naturally-raised desi cattle for maximum nutrient value." },
    { icon: "worm", title: "Earthworm Processed", desc: "Carefully processed by earthworms in a controlled environment for premium quality." },
    { icon: "certificate", title: "FCO Certified", desc: "Meets the Fertilizer Control Order standards set by the Government of India." },
    { icon: "growth", title: "Boosts Plant Growth", desc: "Rich in N, P, K and natural hormones - visible results in weeks, not months." },
    { icon: "vitamin", title: "Vitamin Tonic for Plants", desc: "Vermiwash boosts plant immunity naturally, helping protect against pests, diseases, and environmental stress." }
  ];
  return (
    <section className="section usp-section" id="usp" aria-label="Key benefits">
      <div className="section-inner">
        <div className="section-head center">
          <span className="section-label">Why Choose Paras Organics</span>
          <h2 className="section-title">Purity You Can See. Results You Can Trust.</h2>
        </div>
        <div className="usp-grid">
          {usps.map((u, i) => (
            <div key={i} className="usp-card">
              <div className="usp-head">
                <div className="usp-icon">
                  <USPLineIcon type={u.icon} />
                </div>
                <div className="usp-title">{u.title}</div>
              </div>
              <div className="usp-desc">{u.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

